/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdStickyToolProps, TdStickyItemProps } from './type';

export const stickyToolDefaultProps: TdStickyToolProps = {
  list: [],
  placement: 'right-bottom',
  shape: 'square',
  type: 'normal',
};

export const stickyItemDefaultProps: TdStickyItemProps = { trigger: 'hover' };
